export default __webpack_public_path__ + "static/media/circle-purple.7af08022.svg";